<template>
  <section class="cardd" id="howfunction">
    <div class="content">
      <h1 class="title">
        <span class="light">¿CÓMO</span>
        <span class="bold"> FUNCIONA?</span>
      </h1>

      <div class="steps" ref="steps" @scroll.passive="onScroll">
        <article class="step" :class="{ active: currentIndex === 0 }">
          <img src="../assets/IMG/pide_web.webp" class="icon" alt="Pide tu tarjeta" />
          <h2>1. Pide tu tarjeta</h2>
          <p>Elige color, logo y como quieres que se personalice tu tarjeta.</p>
        </article>

        <article class="step" :class="{ active: currentIndex === 1 }">
          <img src="../assets/IMG/cuenta_web.webp" class="icon" alt="Crea tu cuenta" />
          <h2>2. Crea tu cuenta</h2>
          <p>Configura tu perfil con la información y enlaces que tu prefieras.</p>
        </article>

        <article class="step" :class="{ active: currentIndex === 2 }">
          <img src="../assets/IMG/comparte_web.webp" class="icon" alt="Comparte" />
          <h2>3. Comparte</h2>
          <p>Una vez configurados tus datos, solo debes acercar tu tarjeta a cualquier celular.</p>
        </article>
      </div>

      <div class="controls">
        <button class="nav-btn" type="button" @click="prev" aria-label="Anterior">‹</button>

        <div class="dots" aria-label="Paginación">
          <span
            v-for="n in total"
            :key="n"
            class="dot"
            :class="{ active: currentIndex === (n - 1) }"
            @click="goTo(n - 1)"
          ></span>
        </div>

        <button class="nav-btn" type="button" @click="next" aria-label="Siguiente">›</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HowFunction",
  data() {
    return {
      currentIndex: 0,
      total: 3,
    };
  },
  methods: {
    onScroll() {
      const el = this.$refs.steps;
      if (!el) return;

      const center = el.scrollLeft + el.clientWidth / 2;
      const slides = Array.from(el.querySelectorAll(".step"));

      let best = 0;
      let bestDist = Infinity;

      slides.forEach((s, i) => {
        const slideCenter = s.offsetLeft + s.offsetWidth / 2;
        const dist = Math.abs(center - slideCenter);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });

      this.currentIndex = best;
    },

    goTo(index) {
      const el = this.$refs.steps;
      if (!el) return;

      const slides = Array.from(el.querySelectorAll(".step"));
      const target = slides[index];
      if (!target) return;

      const left = target.offsetLeft - (el.clientWidth - target.offsetWidth) / 2;

      el.scrollTo({ left, behavior: "smooth" });
      this.currentIndex = index;
    },

    prev() {
      this.goTo((this.currentIndex - 1 + this.total) % this.total);
    },

    next() {
      this.goTo((this.currentIndex + 1) % this.total);
    },
  },
  mounted() {
    this.$nextTick(() => this.goTo(0));
  },
};
</script>

<style scoped>
@font-face {
  font-family: "TT Chocolates Trial";
  src: url("@/assets/fonts/TT Chocolates Trial Bold.otf") format("opentype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

.cardd {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: #050505;
  background-image: url("@/assets/IMG/NOSOTROS.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin: 0;
  padding: 0;
}

.cardd::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 0;
}

.content {
  position: relative;
  z-index: 1;
  width: min(1200px, 92%);
  padding: 70px 0 70px;
}

.title {
  margin: 0 0 48px 0;
  text-align: center;
  color: #ffffff;
  font-family: "Exo", sans-serif;
  font-size: clamp(34px, 5vw, 64px);
  line-height: 1;
}

.title .light { font-weight: 300; }
.title .bold {
  font-family: "TT Chocolates Trial", sans-serif;
  font-weight: 700;
  letter-spacing: 0.05em;
}

.steps {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(20px, 3vw, 44px);
  align-items: start;
}

.step {
  text-align: center;
  transition: transform 220ms ease, opacity 220ms ease;
}

.icon {
  width: clamp(170px, 18vw, 260px);
  height: auto;
  display: block;
  margin: 0 auto 18px;
}

.step h2 {
  margin: 10px 0 10px;
  font-family: "Exo", sans-serif;
  color: #ffffff;
  font-size: clamp(18px, 2vw, 26px);
  font-weight: 700;
}

.step p {
  margin: 0 auto;
  max-width: 360px;
  font-family: "Exo", sans-serif;
  color: rgba(255, 255, 255, 0.88);
  font-size: clamp(15px, 1.4vw, 19px);
  font-weight: 500;
  line-height: 1.5;
}

.controls { display: none; }

@media (max-width: 767px) {
  .content {
    width: min(980px, 94%);
    padding: 70px 0 60px;
  }

  .title {
    margin-bottom: 26px;
    font-size: clamp(30px, 8vw, 52px);
  }

  .steps {
    display: flex;
    gap: 18px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;


    padding: 14px calc((100vw - min(560px, 86vw)) / 2) 26px;
    align-items: center;
  }

  .steps::-webkit-scrollbar { height: 0; }
  .steps { scrollbar-width: none; }

  .step {
    width: min(560px, 86vw);
    flex: 0 0 auto;

    scroll-snap-align: center;

    transform: scale(0.86);
    opacity: 0.55;
  }

  .step.active {
    transform: scale(1) translateY(-6px);
    opacity: 1;
  }

  .icon {
    width: min(240px, 55vw);
    margin-bottom: 14px;
  }

  .step h2 { font-size: 22px; }

  .step p {
    font-size: 16px;
    max-width: 480px;
  }

  .controls {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
  }

  .nav-btn {
    width: 44px;
    height: 44px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    font-size: 26px;
    line-height: 1;
    cursor: pointer;
  }

  .dots {
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
  }

  .dot {
    width: 9px;
    height: 9px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.28);
    cursor: pointer;
  }

  .dot.active {
    background: rgba(255, 255, 255, 0.95);
    transform: scale(1.15);
  }
}

@media (max-width: 420px) {
  .step { width: 88vw; }
  .steps { padding-left: 6vw; padding-right: 6vw; }
  .icon { width: 62vw; }
}
/* =========================
   TABLET / iPAD: 2 columnas + más compacto
   (aprox iPad vertical/horizontal)
========================= */
@media (min-width: 768px) and (max-width: 1024px) {
  .cardd {
    min-height: auto;
    padding: 40px 0;
  }

  .content {
    padding: 30px 0 30px;
    width: min(1000px, 92%);
  }

  .title {
    margin-bottom: 30px;
    font-size: clamp(36px, 5vw, 60px);
  }

  .steps {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
    align-items: start;
    justify-items: center;
  }

  .step {
    max-width: 100%;
  }

  .step:nth-child(3) {
    grid-column: 1 / -1;
    max-width: 450px;
  }

  .icon {
    width: clamp(160px, 20vw, 280px);
    margin-bottom: 20px;
  }

  .step h2 {
    font-size: 24px;
    margin-bottom: 12px;
  }

  .step p {
    font-size: 16px;
    max-width: 100%;
  }

  .controls {
    display: none;
  }
}

/* =========================
   iPad PRO / tablets grandes (1025-1200): 3 columnas pero más compactas
========================= */
@media (min-width: 1025px) and (max-width: 1200px) {
  .cardd {
    min-height: 760px;
  }

  .content {
    padding: 60px 0 60px;
  }

  .steps {
    gap: 34px;
  }

  .icon {
    width: clamp(190px, 18vw, 260px);
  }
}

@media (max-width: 767px) {
  .cardd {
    min-height: auto;
    padding: 20px 0 35px;
  }

  .content {
    padding: 45px 0 35px;
  }

  .title {
    margin-bottom: 18px;
  }

  .controls {
    margin-top: 8px;
  }
}

@media (max-width: 420px) {
  .cardd {
    padding: 14px 0 28px;
  }

  .content {
    padding: 38px 0 28px;
  }
}

</style>
